import { memo } from "react";
import { Button, Flex, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import T from "@/components/common/T";
import { NAVY, BRAND, BRAND_GRADIENT, CARD_RADIUS } from "./constants";

const { Title, Text } = Typography;

const img = (seed, w = 480, h = 360) => `https://picsum.photos/seed/${seed}/${w}/${h}`;

// Full-width call-to-action banner prompting users to create a walk in their city.
const CreateWalkBanner = ({ onCreate }) => (
    <div style={{ borderRadius: CARD_RADIUS, overflow: "hidden", position: "relative", minHeight: 280 }}>
        <img
            src={img("ngud-create-walk", 1200, 400)}
            alt="Create a walk"
            style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }}
        />
        <Flex
            vertical
            align="center"
            justify="center"
            gap={14}
            style={{
                position: "relative",
                minHeight: 280,
                textAlign: "center",
                padding: 32,
                background: "linear-gradient(135deg, rgba(11,33,64,0.94) 0%, rgba(23,58,102,0.92) 100%)",
                color: "#fff",
            }}
        >
            <Title level={2} style={{ color: BRAND, margin: 0, textTransform: "uppercase" }}>
                <T k="Is your city not on the map?" />
            </Title>
            <Text style={{ color: "rgba(255,255,255,0.95)", fontSize: 16 }}>
                <T k="Be the first to create a walk in your city." />
            </Text>
            <Button
                size="large"
                icon={<PlusOutlined />}
                onClick={() => onCreate?.()}
                style={{
                    fontWeight: 700, borderRadius: 999, height: 48, paddingInline: 28, marginTop: 8,
                    border: "none", background: BRAND_GRADIENT, color: NAVY,
                }}
            >
                <T k="CREATE YOUR WALK" />
            </Button>
        </Flex>
    </div>
);

export default memo(CreateWalkBanner);
